import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { ApprovePayments, Navigation, TransferRequests, List as Recipients } from './widgets';
import { PageContainer } from '@shared/widgets';

export const PaymentsPage = () => {
  const { t } = useTranslation('payments');

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <div className='flex flex-col gap-6'>
        <div
          className={cn(
            'flex flex-col gap-5',
            PaletteUtils.isVcfcPalette && 'gap-9 rounded-xl bg-white p-6 dark:rounded-xl dark:border dark:border-gray-black dark:bg-soft-black',
          )}
        >
          <Navigation />
          <ApprovePayments />
        </div>
        <Recipients />
        <TransferRequests />
      </div>
    </PageContainer>
  );
};
